var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0m1-11.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m.5 9.5a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1zM11 8.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m.5 9.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditList = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditList);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDdDOSA4LjEwNDU3IDguMTA0NTcgOSA3IDlDNS44OTU0MyA5IDUgOC4xMDQ1NyA1IDdDNSA1Ljg5NTQzIDUuODk1NDMgNSA3IDVDOC4xMDQ1NyA1IDkgNS44OTU0MyA5IDdaTTEwIDdDMTAgOC42NTY4NSA4LjY1Njg1IDEwIDcgMTBDNS4zNDMxNSAxMCA0IDguNjU2ODUgNCA3QzQgNS4zNDMxNSA1LjM0MzE1IDQgNyA0QzguNjU2ODUgNCAxMCA1LjM0MzE1IDEwIDdaTTkgMTdDOSAxOC4xMDQ2IDguMTA0NTcgMTkgNyAxOUM1Ljg5NTQzIDE5IDUgMTguMTA0NiA1IDE3QzUgMTUuODk1NCA1Ljg5NTQzIDE1IDcgMTVDOC4xMDQ1NyAxNSA5IDE1Ljg5NTQgOSAxN1pNMTAgMTdDMTAgMTguNjU2OSA4LjY1Njg1IDIwIDcgMjBDNS4zNDMxNSAyMCA0IDE4LjY1NjkgNCAxN0M0IDE1LjM0MzEgNS4zNDMxNSAxNCA3IDE0QzguNjU2ODUgMTQgMTAgMTUuMzQzMSAxMCAxN1pNMTEgNS41QzExIDUuMjIzODYgMTEuMjIzOSA1IDExLjUgNUgxOS41QzE5Ljc3NjEgNSAyMCA1LjIyMzg2IDIwIDUuNUMyMCA1Ljc3NjE0IDE5Ljc3NjEgNiAxOS41IDZIMTEuNUMxMS4yMjM5IDYgMTEgNS43NzYxNCAxMSA1LjVaTTExLjUgMTVDMTEuMjIzOSAxNSAxMSAxNS4yMjM5IDExIDE1LjVDMTEgMTUuNzc2MSAxMS4yMjM5IDE2IDExLjUgMTZIMTkuNUMxOS43NzYxIDE2IDIwIDE1Ljc3NjEgMjAgMTUuNUMyMCAxNS4yMjM5IDE5Ljc3NjEgMTUgMTkuNSAxNUgxMS41Wk0xMSA4LjVDMTEgOC4yMjM4NiAxMS4yMjM5IDggMTEuNSA4SDE3LjVDMTcuNzc2MSA4IDE4IDguMjIzODYgMTggOC41QzE4IDguNzc2MTQgMTcuNzc2MSA5IDE3LjUgOUgxMS41QzExLjIyMzkgOSAxMSA4Ljc3NjE0IDExIDguNVpNMTEuNSAxOEMxMS4yMjM5IDE4IDExIDE4LjIyMzkgMTEgMTguNUMxMSAxOC43NzYxIDExLjIyMzkgMTkgMTEuNSAxOUgxNy41QzE3Ljc3NjEgMTkgMTggMTguNzc2MSAxOCAxOC41QzE4IDE4LjIyMzkgMTcuNzc2MSAxOCAxNy41IDE4SDExLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";